import { Outlet } from 'react-router-dom';

import PopupManager from '../components/Popup/PopupManager';
import ToastManager from '../components/Toast/ToastManager';
import { PublicProvider } from '../contexts/PublicContext';
import DetailModalManager from '../features/Commons/DetailModal/DetailModalManager';

const ShareLayout = () => {
  return (
    <PublicProvider isPublic={true}>
      <ToastManager />
      <PopupManager />
      <DetailModalManager />
      <Outlet />
    </PublicProvider>
  );
};

export default ShareLayout;
